export enum AlertType {
  SUCCESS = 'success',
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error',
  PENDING_REQUEST = 'pending-request',
  REJECTED_REQUEST = 'rejected-request',
  APPROVED_REQUEST = 'approved-request',
  WAITING_ADMIN_APPROVAL = 'waiting-admin-approval',
  UPDATE_WAITING_ADMIN_APPROVAL = 'update-waiting-admin-approval',
  DENY_BY_ADMIN = 'deny-by-admin',
}
